var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "postGrid", staticClass: "dc-post-grid-component-wrapper" },
    [
      _c(
        "header",
        {
          staticClass: "dc-post-grid-header",
          attrs: { slot: "dc-post-grid-header" },
          slot: "dc-post-grid-header"
        },
        [
          _vm.title || _vm.subtitle
            ? _c(
                "div",
                {
                  staticClass: "dc-post-grid-top-left",
                  attrs: { slot: "dc-post-grid-top-left" },
                  slot: "dc-post-grid-top-left"
                },
                [
                  _vm.title
                    ? _c("h2", { staticClass: "section-title-default" }, [
                        _vm._v(_vm._s(_vm.title))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.subtitle
                    ? _c("h3", { staticClass: "section-subtitle-default" }, [
                        _vm._v(_vm._s(_vm.subtitle))
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.filters || _vm.search_form_placeholder
            ? _c(
                "div",
                {
                  staticClass: "dc-post-grid-top-right",
                  attrs: { slot: "dc-post-grid-top-right" },
                  slot: "dc-post-grid-top-right"
                },
                [
                  _vm.link && typeof _vm.link.url !== "undefined"
                    ? _c(
                        "a",
                        {
                          class: _vm.link.class || "",
                          attrs: { href: _vm.link.url, target: _vm.link.target }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" + _vm._s(_vm.link.title) + "\n\t\t\t"
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentPaged !== null
                    ? _c("Filters", {
                        attrs: {
                          filterLabel: _vm.label_before_filters,
                          filters: _vm.filters,
                          initialModel: _vm.initial_model,
                          currentPaged: _vm.currentPaged,
                          searchButtonId: _vm.searchButtonId,
                          searchFormPlaceholder: _vm.search_form_placeholder
                        },
                        on: {
                          results: _vm.updateResults,
                          "update-total-pages": _vm.updateTotalPages,
                          "update-current-paged": _vm.updateCurrentPaged,
                          "update-post-grid-min-height": _vm.updateMinHeight
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.results
        ? _c(
            "div",
            {
              class: [
                "dc-post-grid-results",
                "uses-no-image-card-fallbacks",
                _vm.columnsClass
              ],
              attrs: { slot: "dc-post-grid-results" },
              slot: "dc-post-grid-results"
            },
            [
              _c("DcPostGridResults", {
                ref: "resultsSection",
                attrs: {
                  results: _vm.results,
                  loading: _vm.loading,
                  gridLayout: _vm.grid_layout,
                  searchButtonId: _vm.searchButtonId,
                  showLoadMore: _vm.showLoadMore,
                  currentPaged: _vm.currentPaged,
                  totalPages: _vm.totalPages,
                  endOfResults: _vm.endOfResults
                },
                on: {
                  "update-current-paged": _vm.updateCurrentPaged,
                  "load-more": _vm.loadMore
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("footer", {
        staticClass: "dc-post-grid-footer",
        attrs: { slot: "dc-post-grid-footer" },
        slot: "dc-post-grid-footer"
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }